export const environment = {
 
  production: true,
  serviceWorker: true,
  apiPort:443,
  pushNotificationsPublicKey: "BKgMhc-Z3UrppWhpzzpt05bEtW8201GmexqegHVp7AoyLm4mrc8rSrA62SuEAi4K0ctJA1chPKlYR_3lOCsV5vg",

};
